/**
 * CssClasses which are used to identify controls.
 * @hidden
 */
export class CssClass {
    public static add = "dms-function-add";
    public static edit = "dms-function-edit";
    public static delete = "dms-function-delete";
    public static update = "dms-function-update";
    public static multipageupdate = "dms-function-multipageupdate";
    public static datasetcommand = "dms-function-datasetcommand";
    public static columnselectorcommand = "dms-function-columnselectorcommand";
    public static cancel = "dms-function-cancel";
    public static link = "dms-function-link";
    public static textblock = "dms-function-textblock";
    public static command = "dms-function-command";
    public static image = "dms-function-image";
    public static export = "dms-function-export";
    public static addToolbar = "dms-function-addToolbar";
    public static contextMenu = "dms-function-contextmenu";
    public static databaseImage = "dms-function-databaseimage";
    public static defaultButton = "dms-default-button";

    public static alignLeft = "dms-align-left";
    public static alignRight = "dms-align-right";
    public static alignCenter = "dms-align-center";

    public static columneditable = "dms-column-editable";

    public static isCollapsed = "dms-iscollapsed";
    public static hidden = "dms-hidden";

    public static userGridConfig = "dms-usergridconfig";
}
